import React from "react";
import styled from "styled-components";

const ButtonContainer = styled.div`
  cursor: pointer;
  padding: 10px 20px;
  text-align: center;
  border-radius: 5px;

  background: var(--primary);
  color: var(--white);

  width: ${({ width }) => (width ? width : "auto")};
`;

export const Button = ({ text, action, type }) => {
  return (
    <ButtonContainer type={type} onClick={action}>
      {text}
    </ButtonContainer>
  );
};

export default Button;
